import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AgentsService } from '@app/services/agents.service';

@Component({
  selector: 'blu-agent-faq',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './faq.component.html',
  styleUrl: './faq.component.scss',
})
export class FAQComponent {
  agent$ = this.agentsService.agent$;
  expandedFAQ?: number;

  constructor(private agentsService: AgentsService) {}

  addFAQ() {
    const agent = this.agentsService.getCurrentAgent();
    if (!agent.configuration.faq) {
      agent.configuration.faq = [];
    }
    agent.configuration.faq.push({ question: '', answer: '' });
  }

  removeFAQ(index: number) {
    const agent = this.agentsService.getCurrentAgent();
    if (!agent.configuration.faq) return;
    agent.configuration.faq.splice(index, 1);
  }
}
